<template>
  <div>
    <div class="l-row">
      <form-group :label="$t('price.type.label')">
        <select v-model="options.type" class="form-select">
          <option :value=null>{{ $t('choose.label') }}</option>
          <option v-for="priceType in priceTypeDI" :key="priceType" :value="priceType">
            {{ priceType === 'source' ? $t('priceTypeModule.label') + $t('module.label') : $t(priceType).label }}
          </option>
        </select>
      </form-group>
      <div class="l-col-4@md center" v-if="fileExample">
        <span><a :href="fileExample" download>Arquivo de exemplo</a></span>
      </div>
    </div>

    <div class="l-row">
      <form-group label="Arquivo (formato csv de no máx. 4MB)" v-if="options.type" :columns="6">
        <upload-file :validateFunction="validateFile" v-on:file="getFile" :data="uploadFileData"/>
      </form-group>
    </div>
  </div>
</template>

<script>
  import FormGroup from '@/components/template/FormGroup'
  import UploadFile from '@/components/template/UploadFile'
  import ProductPriceConfiguration from '@/components/shared/ProductPriceConfiguration'
  import notifier from '@/notifier'

  export default {
    inject: ['priceTypeDI'],
    data: () => ({
      uploadFileData: {
        fileType: [
          'text/csv',
          'csv'
        ],
        fileSize: 4194304
      },
      options: {
        file: '',
        type: null
      },
      fileExample: null
    }),
    props: {
      module: {
        type: Object,
        required: true
      }
    },
    methods: {
      validateFile (headerFile) {
        let pattern = ''
        switch (this.options.type) {
          case 'source':
            pattern = 'sku'
            if (this.module.identifier === 'mercadoLivre') {
              pattern = 'code'
            }
            break
          case 'custom':
            pattern = 'sku;from;to'
            if (this.module.identifier === 'mercadoLivre') {
              pattern = 'code;from;to'
            }
            break
          case 'percent':
            pattern = 'sku;percent'
            if (this.module.identifier === 'mercadoLivre') {
              pattern = 'code;percent'
            }
            break
          case 'fixedValue':
            pattern = 'sku;fixedValue'
            if (this.module.identifier === 'mercadoLivre') {
              pattern = 'code;fixedValue'
            }
            break
        }

        if (headerFile !== pattern) {
          notifier.error('Formato do arquivo inválido.', 'Erro')
          return false
        }

        return true
      },
      getFile (url) {
        this.options.file = url
      },
      getOptions () {
        return {
          file: this.options.file,
          type: this.options.type
        }
      }
    },
    watch: {
      'options.type' (value) {
        switch (value) {
          case 'source':
            this.fileExample = 'http://public.placemarket.com.br/tool/batch/examples/Exemplo+Pre%C3%A7o+M%C3%B3dulo.csv'
            if (this.module.identifier === 'mercadoLivre') {
              this.fileExample = 'http://public.placemarket.com.br/tool/batch/examples/Exemplo+Pre%C3%A7o+M%C3%B3dulo+Mercado+Livre.csv'
            }
            break
          case 'custom':
            this.fileExample = 'https://public.placemarket.com.br/tool/batch/examples/Exemplo+Pre%C3%A7o+Customizado.csv'
            if (this.module.identifier === 'mercadoLivre') {
              this.fileExample = 'http://public.placemarket.com.br/tool/batch/examples/Exemplo+Pre%C3%A7o+Customizado+Mercado+Livre.csv'
            }
            break
          case 'percent':
            this.fileExample = 'https://public.placemarket.com.br/tool/batch/examples/Exemplo+Pre%C3%A7o+Percentual.csv'
            if (this.module.identifier === 'mercadoLivre') {
              this.fileExample = 'https://public.placemarket.com.br/tool/batch/examples/Exemplo+Pre%C3%A7o+Percentual+Mercado+Livre.csv'
            }
            break
          case 'fixedValue':
            this.fileExample = 'https://public.placemarket.com.br/tool/batch/examples/Exemplo+Pre%C3%A7o+Valor+Fixo.csv'
            if (this.module.identifier === 'mercadoLivre') {
              this.fileExample = 'https://public.placemarket.com.br/tool/batch/examples/Exemplo+Pre%C3%A7o+Valor+Fixo+Mercado+Livre.csv'
            }
            break
          default:
            this.fileExample = null
        }
      }
    },
    components: {
      FormGroup,
      UploadFile,
      ProductPriceConfiguration
    }
  }
</script>

<style lang="sass" scoped>
  .center
    margin-top: 30px

</style>



// WEBPACK FOOTER //
// Options.vue?2d8f1e01